import { memo } from 'react';
import { TrackingProgressBar } from '../TrackingProgressBar/TrackingProgressBar';
import { TXCenterBadge } from '../TXCenterBadge/TXCenterBadge';

type RouteProgressRowProps = {
  donorHospitalCode?: string;
  txCenterCode?: string;
  progress: number;
  variant?: 'animated' | 'static' | 'completed';
};

export const RouteProgressRow = memo(
  ({ donorHospitalCode, txCenterCode, progress, variant = 'static' }: RouteProgressRowProps) => (
    <div className="flex items-center gap-2">
      {donorHospitalCode ? <TXCenterBadge txCenterCode={donorHospitalCode} /> : null}
      <div className="flex-1">
        <TrackingProgressBar progress={progress} variant={variant} />
      </div>
      {txCenterCode ? <TXCenterBadge txCenterCode={txCenterCode} /> : null}
    </div>
  ),
);
